import request from '@/utils/request';
import { iHotGameSearch, iSort, iHotGameDetails } from '@/interface/hot-game';
/**
 * 热门游戏列表
 * @param params
 */
export const getHotGame = (params: iHotGameSearch): Promise<any> =>
  request({
    params,
    url: '/api/v1/omc/game/hot/list',
  });

/**
 * 排序
 * @param params
 */

export const setSort = (data: any): Promise<any> =>
  request({
    url: '/api/v1/omc/game/hot/sort',
    method: 'put',
    data,
  });
/**
 * 发布
 * @param params
 */

export const setRelease = (endpoint: number) =>
  request({
    url: '/api/v1/omc/game/hot/release/' + endpoint,
    method: 'put',
  });

/**
 * 新增热门游戏
 * @param params
 */

export const postAddHostGame = (data: any): Promise<any> =>
  request({
    url: '/api/v1/omc/game/hot/save',
    method: 'post',
    data,
  });
/**
 * 编辑
 * @param params
 */
export const postEditHostGame = (data: any): Promise<any> =>
  request({
    url: '/api/v1/omc/game/hot/edit',
    method: 'PUT',
    data,
  });
/* 删除热门游戏 */
export const delHotGame = (data: any) => {
  return request({
    url: `/api/v1/omc/game/hot/remove?id=${data[0]}&version=${data[1]}`,
    method: 'delete',
    data,
  });
};
